import { useContent } from '../../../../hooks/use-server-content';
import { ActionItemCombinedContent } from '../../../../models/experiencefragments/action-item';

export const useServiceReminderCombinedContent = (): ActionItemCombinedContent => {
    const [content, getValueByName] = useContent(
        'vehicles/action-items',
        'service-reminders-action-item'
    );
    const contentFragment = {} as any;
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment;
};
